var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('form',{staticClass:"form-horizontal",attrs:{"role":"form"}},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-default btn-lg btn-block",on:{"click":_vm.login}},[_vm._v("登录")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88b30eb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/login.vue
// module id = null
// module chunks = 